module.exports = __webpack_public_path__ + "img/bianji.3ff08df6.png";